<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-card flat>
      <v-container>
        <v-row>
          <v-col cols="auto">
            <v-card-text>
              <v-img :src="$images.SIGNOFF" width="100"></v-img>
            </v-card-text>
          </v-col>
          <v-col>
            <v-row>
              <v-card-title>
                Sign Off On Review
              </v-card-title>
              <v-spacer></v-spacer>
              <v-col cols="auto">
                <v-btn icon @click="cancel">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-card-text class="pa-0">
              <v-row>
                <v-col cols="12" class="py-0">
                  Clicking the button below means you approve of this review
                  being submitted to HR.
                </v-col>
                <v-col cols="auto" class="my-auto">
                  <v-btn
                    v-if="!saved"
                    color="primary"
                    @click="save"
                    :loading="saving"
                  >
                    Approve Review
                  </v-btn>
                  <v-btn v-else color="success">
                    Approved Review
                  </v-btn>
                </v-col>
                <v-col cols="auto" class="my-auto">
                  <v-badge
                    overlap
                    icon="check"
                    :color="!saved ? 'lighttext' : 'success'"
                  >
                    <user-avatar
                      size="50"
                      :user="user"
                      borderColor="performance"
                      color="performance"
                      cssClass="halo"
                      textColor="white"
                    ></user-avatar>
                  </v-badge>
                </v-col>
              </v-row>
            </v-card-text>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AnnualReviewSignoffDialog",
  components: {},
  props: {},
  data: () => ({
    dialog: false,
    valid: false,
    saving: false,
    saved: false,
    answer: {},
    user: ""
  }),
  watch: {},
  computed: {},
  methods: {
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    showDialog(user) {
      this.dialog = true;
      this.user = user;
      this.saved = false;
    },
    save() {
      this.saving = true;
      this.$store
        .dispatch("annualreview/signoff")
        .then(() => {
          this.$emit("save");
          this.$root.$snackbarSuccess("Signoff submitted");
          this.saved = true;
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occurred while submitting your signoff."
          );
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
